import { render, staticRenderFns } from "./EmployeeBoardLane.vue?vue&type=template&id=058230ff&scoped=true&"
import script from "./EmployeeBoardLane.vue?vue&type=script&lang=js&"
export * from "./EmployeeBoardLane.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBoardLane.vue?vue&type=style&index=0&id=058230ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058230ff",
  null
  
)

export default component.exports